module.exports = __webpack_public_path__ + "static/home-hero-desktop.593a1239.webp";